/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import { useTranslate } from "../../hooks/useTranslate";

const StyledTitle = styled.div`
  margin: 0;
  font-weight: 600;
  ${(props) => colorStyles[props.$color]}
  ${(props) => sizeStyles[props.$size]}
  ${(props) => lineClampStyles(props)}
`;

const lineClampStyles = (props) => css`
  ${!!props.$lineClamp && css`
    display: -webkit-box;
    -webkit-line-clamp: ${props.$lineClamp};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const colorStyles = {
  dark: css`
    color: rgba(${({ theme }) => theme.colors.text.rgba});
  `,
  link: css`
    color: rgba(${({ theme }) => theme.colors.link.rgba});
  `,
};

const Title = ({ size = "h1", color = "dark", lineClamp = 0, children, ...props }) => {
  const { _t } = useTranslate();
  return (
    <StyledTitle as={size} $size={size} $color={color} $lineClamp={lineClamp} {...props}>
      {_t(children)}
    </StyledTitle>
  );
};

const sizeStyles = {
  h2: css`
    font-size: ${({ theme }) => theme.fontSizes.h2};
    line-height: 1.17;

    ${({ theme }) => theme.containerMedia.sm} {
      font-size: calc(${({ theme }) => theme.fontSizes.h2} * 0.909);
      line-height: 1.2;
    }
  `,
  h3: css`
    font-size: ${({ theme }) => theme.fontSizes.h3};
    line-height: 1.5;

    ${({ theme }) => theme.containerMedia.sm} {
      font-size: calc(${({ theme }) => theme.fontSizes.h3} * 0.909);
    }
  `,
};

export { sizeStyles as titleSizeStyles };
export default Title;
